export class Country {
    constructor(
        id,
        name,
        continent,
    ) {
        this.id = id;
        this.name = name;
        this.continent = continent;
    }
}